import type { TLanguageCode } from '@motopays/pay-form';

import type { RouterLocale } from '~i18n/constants';

export const languages: Record<RouterLocale, string> = {
	en: 'English',
	de: 'Deutsch',
	fr: 'French',
	ja: 'Japanese',
	es: 'Spanish',
	pt: 'Portuguese',
};

export const languagesAsArray = Object.entries(languages).map(
	([locale, name]) => ({ locale: locale as RouterLocale, name })
);

// based on TLanguageCode
type MotoDefaultLocaleMap = {
	en: 'en-US';
	es: 'es-ES';
	fr: 'fr-FR';
};

const motoDefaultLocaleMap: MotoDefaultLocaleMap = {
	en: 'en-US',
	fr: 'fr-FR',
	es: 'es-ES',
};

type FullLocaleMap = {
	[K in keyof MotoDefaultLocaleMap]: MotoDefaultLocaleMap[K];
} & {
	[K in Exclude<RouterLocale, keyof MotoDefaultLocaleMap>]: TLanguageCode;
};

export const fullLocaleMap: FullLocaleMap = Object.fromEntries(
	Object.keys(languages).map((locale) => [
		locale,
		motoDefaultLocaleMap[locale as keyof MotoDefaultLocaleMap] ?? locale,
	])
) as FullLocaleMap;

export const fullLocalesArray = Object.values(fullLocaleMap);
